import { render } from "./ModalPersonalize.vue?vue&type=template&id=2e0158d8&scoped=true"
import script from "./ModalPersonalize.vue?vue&type=script&lang=js"
export * from "./ModalPersonalize.vue?vue&type=script&lang=js"

import "./ModalPersonalize.vue?vue&type=style&index=0&id=2e0158d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0158d8"]])

export default __exports__